import React, { useState } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';

const MerchantResetAPISecretConfirmModal: React.FC<{
    details: any;
    isOpen: boolean;
    onClose(): void;
    triggerReload(): void;
    setSwalProps: any;
    showMerchantResetAPISecretSuccessModal: any;
    setResetAPISecretInfo: any;
    setApiSecret: any;
}> = ({ isOpen, onClose, triggerReload, details, setSwalProps, showMerchantResetAPISecretSuccessModal, setResetAPISecretInfo, setApiSecret }) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const closeModal = async () => {
        onClose();
    };

    const handleSubmit = async () => {
        setIsProcessing(true);
        try {
            await axios.post(process.env.REACT_APP_API_URL + `/api/merchant/action`, {
                fn: "reset-api-secret",
                id: details.id,
                username: localStorage.getItem("username"),
                userRole: localStorage.getItem("userRole")
            }).then(function (response) {
                if (response && response.data?.status === 'ok') {
                    setIsProcessing(false);
                    closeModal();
                    triggerReload();
                    setResetAPISecretInfo(response.data.info);
                    setApiSecret(response.data.info.auth2);
                    showMerchantResetAPISecretSuccessModal(true);
                } else {
                    closeModal();
                    setIsProcessing(false);
                    setSwalProps({
                        show: true,
                        icon: "error",
                        title: "Oops!",
                        html: response.data.message,
                        showConfirmButton: true,
                        didClose: () => {
                            setSwalProps({});
                        },
                    });
                }
            }).catch(function (error) {
                closeModal();
                setIsProcessing(false);
                setSwalProps({
                    show: true,
                    icon: "error",
                    title: "Oops!",
                    html: error.response.data.message,
                    showConfirmButton: true,
                    didClose: () => {
                        setSwalProps({});
                    },
                });
            });
        } catch (error) {
            closeModal();
            console.error("Error reset api secret", error);
            setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: "Something went wrong, please try again later.",
                showConfirmButton: true,
                didClose: () => {
                    setSwalProps({});
                },
            });
            return false;
        }
    };

    return (
        <>
            {details &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]">
                        <ModalBody className="!text-navy-700">
                            <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004]">
                                <h1 className="mb-[20px] text-2xl font-bold">Are you sure you want to reset the API Secret?</h1>
                                <div className="mb-[20px text-sm">
                                    <div className="mb-8">
                                        Please confirm if you wish to reset the API Secret for the current merchant.
                                    </div>
                                </div>
                                <div className="flex gap-2 justify-end">
                                    <Button
                                        onClick={() => closeModal()}
                                        isDisabled={isProcessing}
                                        className="btn btn-default"
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        onClick={() => handleSubmit()}
                                        isLoading={isProcessing}
                                        loadingText='Processing...'
                                        className="btn btn-primary">
                                        Confirm
                                    </Button>
                                </div>
                            </Card>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default MerchantResetAPISecretConfirmModal;
